import { Tabs } from '@mantine/core'
import { IconRobot } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { Outlet, useLocation, useNavigate } from 'react-router'
import { FixedPageTitle } from '@/components/layout/PageWithFixedToolbar/FixedPageTitle'
import { PageWithFixedToolbar } from '@/components/layout/PageWithFixedToolbar/PageWithFixedToolbar'
import { RouterPath, VlmNestedPath } from '@/router/paths'

export const VlmPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const getCurrentTab = () => {
    const allTabs = Object.values(VlmNestedPath)

    const activeTab = allTabs.find((tab) =>
      location.pathname.endsWith(`/${tab}`)
    )

    return activeTab ?? VlmNestedPath.hardware
  }

  const currentTab = getCurrentTab()

  const handleTabChange = (value: string | null) => {
    const targetPath = value || VlmNestedPath.hardware
    void navigate(`${RouterPath.vlm}/${targetPath}`)
  }

  return (
    <PageWithFixedToolbar
      maxWidth={1400}
      toolbar={
        <FixedPageTitle
          title={<FormattedMessage id="vlm.title" />}
          icon={<IconRobot size={24} color="var(--mantine-color-orange-6)" />}
        />
      }
    >
      <Tabs
        value={currentTab}
        mb="xl"
        variant="outline"
        styles={{
          tabLabel: {
            fontWeight: 600
          }
        }}
        onChange={handleTabChange}
      >
        <Tabs.List>
          <Tabs.Tab value={VlmNestedPath.hardware}>
            <FormattedMessage id="vlm.tabs.hardware" />
          </Tabs.Tab>

          <Tabs.Tab value={VlmNestedPath.pipelines}>
            <FormattedMessage id="vlm.tabs.pipelines" />
          </Tabs.Tab>

          <Tabs.Tab value={VlmNestedPath.results}>
            <FormattedMessage id="vlm.tabs.results" />
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>

      <Outlet />
    </PageWithFixedToolbar>
  )
}
